/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiASkipBackIcon16Solid = forwardRef('MediaUiASkipBackIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M11.485 2.255 5.13 6.688A1.65 1.65 0 0 0 5 6.789V3a1 1 0 1 0-2 0v10a1 1 0 1 0 2 0V9.212c.041.035.085.07.13.101l6.355 4.433c1.06.74 2.515-.019 2.515-1.312V3.567c0-1.293-1.455-2.052-2.515-1.312Z" })));
});
